import api from "./Api";

class FechamentoVendasCupomControleService {
  GetFechamentoVendasCupomControle(payload) {
    return api
      .get("/v1/fechamentoVendasCupomControle/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostFechamentoVendasCupomControle(payload) {
    return api
      .post("/v1/fechamentoVendasCupomControle/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutFechamentoVendasCupomControle(payload) {
    return api
      .put("/v1/fechamentoVendasCupomControle/", payload)
      .then((response) => {
        return response.data;
      });
  }

  DeleteFechamentoVendasCupomControle(payload) {
    return api
      .delete("/v1/fechamentoVendasCupomControle/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetFechamentoVendasCupomControleOData(payload) {
    return api
      .get("/OData/FechamentoVendasCupomControle" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new FechamentoVendasCupomControleService();
